<app-header></app-header>
<app-left-side></app-left-side>
<router-outlet></router-outlet>
<app-footer></app-footer>